import api from "../api";

//user buying a subscription
export const createSubscription = async (planId) => {
  return api.post("/v1/api/subscriptions/create", { plan_id: planId });
};
// Get user's current subscription
export const getUserSubscription = async () => {
  return api.get("/v1/api/subscriptions/get");
};
